import React from 'react';
import { TextField, Filter, DateField } from 'react-admin';
import Box from '@material-ui/core/Box';

import { Datagrid, List, Actions } from 'components/list';

import { ActionField, EmailField } from 'components/fields';
import SearchInput from 'components/list/SearchInput';
import EnableSubUserAction from './sub-users/EnableSubUserAction';
import DeleteSubUserAction from './sub-users/DeleteSubUserAction';
import EditSubUserAction from './sub-users/EditSubUserAction';
import FullNameField from './sub-users/FullNameField';
import SubUserStatus from './sub-users/SubUserStatus';
import { makeStyles } from '@material-ui/core';
import CreateSubUserButton from './sub-users/CreateSubUserButton';

const useStyles = makeStyles(() => ({
  form: {
    width: '100%',
    '& .filter-field': {
      width: '100%',
    },
    minHeight: 0,
    marginTop: 0,
  },
  button: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    maxWidth: 180,
    minWidth: 145,
    alignSelf: 'flex-start',
    marginRight: 8,
    boxShadow: 'none',
  },
}));

const SubUsersFilters = (props) => {
  const classes = useStyles();

  return (
    <Filter classes={classes} {...props}>
      <SearchInput
        label="Search"
        source="search"
        alwaysOn
        onlySearch
        loading={props.loading}
        fullWidth
      />
    </Filter>
  );
};

const SubUsersActions = (props) => {
  const classes = useStyles();

  return (
    <Actions {...props}>
      <Box className={classes.button}>
        <CreateSubUserButton tenantId={props.id} />
      </Box>
    </Actions>
  );
};

const SubUsersManagementTab = (props) => {
  return (
    <List
      {...props}
      actions={<SubUsersActions id={props.id} />}
      filters={<SubUsersFilters />}
      resource="membersList"
      basePath="/users"
      filter={{ _id: props.id }}
      sort={{ field: 'createdAt', order: 'DESC' }}>
      <Datagrid>
        <TextField source="id" label="Member ID" sortable={false} />
        <FullNameField
          firstNameSource="firstName"
          lastNameSource="secondName"
          label="Name"
          sortable={false}
        />
        <EmailField source="email" label="Email" />
        <TextField source="phone" label="Phone" sortable={false} />
        <TextField source="position" label="Position" />
        <SubUserStatus label="Status" sortable={false} />
        <DateField
          source="createdAt"
          label="Created At"
          options={{
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          }}
        />
        <DateField
          source="updatedAt"
          label="Updated At"
          options={{
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          }}
        />
        <ActionField>
          <EditSubUserAction tenantId={props.id} />
          <EnableSubUserAction tenantId={props.id} />
          <DeleteSubUserAction tenantId={props.id} />
        </ActionField>
      </Datagrid>
    </List>
  );
};

export default SubUsersManagementTab;
